import { Box, IconButton, Typography, styled, Tooltip } from "@mui/material";
import React, { useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { saveAs } from "file-saver";
import { Close, InsertDriveFile } from "@mui/icons-material";
import CustomLoader from "./CustomLoader";

const isImage = (src) =>
  /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(src || "");

const PreviewDownloadImage = ({
  src,
  documentName,
  deleteIcon = false,
  handleDelete = () => {},
}) => {
  const [loading, setLoading] = useState(false);
  const name = src?.substring(src.lastIndexOf("/") + 1);

  const handleDownload = () => {
    setLoading(true);
    const docName = documentName ? documentName : name;
    fetch(src)
      .then((response) => response.blob())
      .then((blob) => {
        saveAs(blob, docName);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  if (!src) return null;

  return (
    <>
      {loading && <CustomLoader show={loading} />}
      <Box>
        <ImageWrapper>
          {isImage(src) ? (
            <img
              src={src}
              alt={documentName || name}
              className="image"
              loading="lazy"
              draggable={false}
            />
          ) : (
            <Box className="file_icon_box" sx={{ borderRadius: 4 }}>
              <InsertDriveFile sx={{ fontSize: 48, color: "#b6c8d6" }} />
            </Box>
          )}
          {deleteIcon && (
            <Tooltip title="Delete">
              <Box className="close_box">
                <Close
                  sx={{
                    fontSize: "15px",
                    cursor: "pointer",
                    color: "rgba(241, 15, 15, 1)",
                  }}
                  onClick={() => handleDelete()}
                  aria-label="Delete file"
                />
              </Box>
            </Tooltip>
          )}
          <Box className="download_box">
            <Tooltip title="Download">
              <span>
                <IconButton
                  onClick={handleDownload}
                  disabled={loading}
                  aria-label="Download file"
                >
                  <DownloadIcon sx={{ color: "#fff", fontSize: "25px" }} />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        </ImageWrapper>
        <Typo>
          {documentName ? documentName : String(name).split(".")[0]}
        </Typo>
      </Box>
    </>
  );
};

export default PreviewDownloadImage;

const Typo = styled(Typography)`
  max-width: 80px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 4px;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
`;

const ImageWrapper = styled(Box)`
  position: relative;
  height: 80px;
  width: 80px;
  background-color: #f5f5f5;
  transition: 0.5s ease;
  cursor: pointer;
  border: 2px solid rgba(182, 200, 214, 0.6);
  border-radius: 8px;
  :hover .download_box {
    opacity: 1;
    border-radius: 8px;
  }
  .image,
  .file_icon_box {
    height: 100%;
    width: 100%;
    object-fit: contain;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
  }
  .download_box {
    z-index: 5;
    transition: 0.5s ease;
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(8, 76, 132, 0.75);
    z-index: 2;
  }
  .close_box {
    z-index: 6;
    position: absolute;
    top: 0;
    right: 0;
    width: 20.82px;
    height: 20.82px;
    background: #ffd7d7;
    border: 0.699798px solid #ffb4b4;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -12px;
    margin-right: -12px;
  }
`;
